import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { map, shareReplay } from 'rxjs/operators';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { PushNotificationsService } from '../../../../auxiliares/servicios/push-notifications.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss'],
  standalone: false,
})
export class NotificacionesComponent implements OnInit, OnDestroy {
  private breakpointObserver = inject(BreakpointObserver);
  private lista2 = inject(Lista2Service);
  private helper = inject(HelperService);

  public notificacionesSinLeer = 0;

  public notifConfiguradas: boolean = true;

  // Listado Continuo
  public datos$?: Subscription;

  private push = inject(PushNotificationsService);
  public notificacionesActivas = signal(false);
  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  public async activarNotificaciones() {
    const estado = await this.push.requestPermission();
    if (estado === 'granted') {
      await this.push.iniciarPermisos();
      this.notificacionesActivas.set(estado === 'granted');
    }
  }

  private async cantidadSinLeer(): Promise<void> {
    try {
      this.datos$?.unsubscribe();
      this.datos$ = this.lista2.notificacionsSinLeer(30).subscribe((data) => {
        this.notificacionesSinLeer = data.totalCount;
      });
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  async ngOnInit(): Promise<void> {
    await this.cantidadSinLeer();
  }

  ngOnDestroy(): void {
    this.datos$?.unsubscribe();
  }
}
